import React, { useContext, useEffect, useState } from "react";
import { UserServiceContext } from "../services/user/userService";
import Loader from "../components/Loader";
import CustomAlert from "../components/CustomAlert";
import ReactDataTable from "react-data-table-component";
import { paginationComponentOptions } from "../utils/constants";
import {
  IconHomePlus,
  IconCloudDownload,
  IconTrash,
  IconEdit,
} from "@tabler/icons-react";
import SubUsersModal from "./app/modals/SubUsersModal";

const SubUsers = () => {
  const { getSubUsers, subUsers, deleteSubUser, loading } =
    useContext(UserServiceContext);
  const [showSubUserModal, setShowSubUserModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedSubUser, setSelectedSubUser] = useState({});
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    text: "",
    icon: "",
    onConfirm: null,
    onCancel: null,
  });

  const fetchSubUsers = async () => {
    await getSubUsers();
  };

  useEffect(() => {
    fetchSubUsers();
  }, []);

  const handleSubUserDelete = async (id) => {
    setAlertConfig({
      show: true,
      title: "გაფრთხილება",
      text: "დარწმუნებული ხართ, რომ გსურთ ქვე მომხმარებლის წაშლა?",
      icon: "warning",
      showConfirmButton: true,
      onConfirm: async () => {
        await deleteSubUser(id);
        setAlertConfig({ show: false });
        fetchSubUsers();
      },
      onCancel: () => {
        setAlertConfig({ ...alertConfig, show: false });
      },
    }); // Reset alert config
  };

  // useEffect(() => {
  //   if (subUsers) {
  //     console.log(subUsers);
  //   }
  // }, [subUsers]);

  const handleModalShow = async () => {
    setShowSubUserModal(!showSubUserModal);
    await fetchSubUsers();
  };

  const handleEditSubUser = (subUser) => {
    setIsEdit(true);
    setSelectedSubUser(subUser);
    setShowSubUserModal(true);
  };

  const columns = [
    {
      name: "მომხმარებელი",
      selector: (row) => row.userName,
      width: "260px",
    },
    {
      name: "სრული სახელი",
      selector: (row) => row.fullName,
      width: "260px",
    },
    {
      name: "ტელეფონი",
      selector: (row) => row.mobile,
      width: "260px",
    },
    {
      name: "ელ. ფოსტა",
      selector: (row) => row.email,
    },
    {
      cell: (row) => (
        <button
          className="btn btn-outline-primary"
          onClick={() => handleEditSubUser(row)}
        >
          <IconEdit className="w-[18px] h-[18px]" />
        </button>
      ),
      width: "70px",
      style: { cursor: "pointer" },
    },
    {
      cell: (row) => (
        <button
          className="btn btn-outline-danger text-red-600 hover:text-red-700"
          onClick={() => handleSubUserDelete(row.id)}
        >
          <IconTrash className="w-[18px] h-[18px]" />
        </button>
      ),
      width: "70px",
      style: { cursor: "pointer" },
    },
  ];

  return (
    <>
      {loading && <Loader />}
      <CustomAlert {...alertConfig} />
      {showSubUserModal && (
        <SubUsersModal
          setShowSubUserModal={handleModalShow}
          isEdit={isEdit}
          originalData={selectedSubUser}
        />
      )}
      <div className="flex items-center justify-between gap-4 flex-wrap mx-20 my-20">
        <h5 className="text-[20px]/[26px]"></h5>
        <div className="flex items-stretch gap-1 flex-wrap">
          <button
            className="btn btn-outline-secondary"
            onClick={() => setShowSubUserModal(true)}
          >
            <IconHomePlus className="w-[18px] h-[18px]" />
            <span className="sm:block hidden">დამატება</span>
          </button>
          <button className="btn btn-outline-secondary">
            <IconCloudDownload className="w-[18px] h-[18px]" />
            <span className="sm:block hidden">ექსპორტი</span>
          </button>
        </div>
      </div>
      <div className="react-data-table mx-20">
        <ReactDataTable
          pagination
          striped
          paginationComponentOptions={paginationComponentOptions}
          columns={columns}
          data={subUsers}
          noDataComponent={
            <div
              style={{ textAlign: "center", padding: "20px", color: "gray" }}
            >
              ქვე მომხმარებლები დამატებული არ გაქვთ
            </div>
          }
        />
      </div>
    </>
  );
};

export default SubUsers;
